import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Item } from '../../../../interfaces/item';
import { Producto, ProductoEstado } from '../../../../interfaces/producto';
import { Validators, FormControl } from '@angular/forms';
import { ProductoService } from '../../../../providers/producto.service';
import { MatCheckboxChange, MatSelectChange, MatSelect } from '@angular/material';
import { AccesorioService } from '../../../../providers/accesorio.service';
import { Accesorio } from '../../../../interfaces/accesorio';
import { TipoProductoCategoria, TipoProducto } from '../../../../interfaces/tipo-producto';
import { ReplaySubject } from 'rxjs';
import { TipoProductoService } from '../../../../providers/tipo-producto.service';
import { TipoPlazo } from '../../../../interfaces/tipo-plazo';
import { TipoPlazoService } from '../../../../providers/tipo-plazo.service';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})
export class ItemComponent implements OnInit {
  @Input() itemData: Item = null;
  item: Item;
  itemPrecioProductoAsignado: number = 0; // precio original del producto antes de hacer cambios en el formulario

  productos: Producto[] = <Producto[]>[];
  cargandoProductos: boolean = false;
  accesorios: Accesorio[] = <Accesorio[]>[];
  cargandoAccesorios: boolean = false;

  tiposProducto: TipoProducto[] = <TipoProducto[]>[];
  cargandoTiposProducto: boolean = false;
  filtroTipoProductoSelected: number = null;
  cargandoTiposPlazo: boolean = false;
  tiposPlazo: TipoPlazo[] = <TipoPlazo[]>[];

  // true si el ítem es con productos especiales
  // false para un ítem con productos de fábrica
  filtroProductosEspeciales: boolean = false;

  @Output() onItemInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario

  // para el select con buscador 
  public productosFiltroCtrl: FormControl = new FormControl();
  public productosFiltrados: ReplaySubject<Producto[]> = new ReplaySubject<Producto[]>(1);
  @ViewChild('selectProducto') selectProducto: MatSelect;

  productoFormControl = new FormControl('', [
    Validators.required
  ]);
  cantidadFormControl = new FormControl('', [
    Validators.required,
    Validators.min(0),
    Validators.max(99999999999)
  ]);

  constructor(
    private productoService: ProductoService,
    private tipoProductoService: TipoProductoService,
    private accesorioService: AccesorioService,
    private tipoPlazoService: TipoPlazoService
  ) { }

  ngOnInit() {
    if (this.itemData) {
      this.item = new Item(
        this.itemData.IdItem,
        this.itemData.producto,
        this.itemData.cantidad,
        this.itemData.precioUnitario,
        this.itemData.etiqueta,
        this.itemData.customDescripcion,
        Object.assign([], this.itemData.accesorios),
        this.itemData.especial,
        this.itemData.productoPrecioIncluido,
        this.itemData.tipoPlazo
      );

      this.itemPrecioProductoAsignado = this.itemData.precioUnitario;

      if (this.item.especial) {
        this.traerAccesorios(null, +this.item.producto.tipo.categoria.IdCategoria);
      } else {
        this.traerAccesorios(+this.item.producto.tipo.id, null);
      }
    } else {
      this.item = new Item();
    }

    this.filtroProductosEspeciales = this.item.especial;
    this.traerTiposProducto();
    this.traerProductos();
    this.traerPlazos();

    // cuando cambia el valor del buscador, filtramos
    this.productosFiltroCtrl.valueChanges.subscribe(() => {
      this.filtrarProductos();
    });

    // le decimos al array con filtro como tiene que comparar
    this.productosFiltrados.subscribe(
      () => {
        this.selectProducto.compareWith = (a: Producto, b: Producto) => {
          if (a && b) {
            return a.IdProducto == b.IdProducto;
          }

          return false;
        }
      }
    );
  }

  traerPlazos(): void {
    this.tiposPlazo = [];
    this.cargandoTiposPlazo = true;
    this.tipoPlazoService.getTiposPlazo(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta && respuesta.data && respuesta.estado == 1 && respuesta.data.plazos) {
          respuesta.data.plazos.forEach((plazo) => {
            this.tiposPlazo.push(<TipoPlazo>{
              id: plazo.id,
              descripcion: plazo.descripcion
            });
          });
        }

        this.cargandoTiposPlazo = false;
      },
      () => {
        this.cargandoTiposPlazo = false;
      }
    );
  }

  traerTiposProducto(): void {
    this.tiposProducto = [];
    this.cargandoTiposProducto = true;
    this.tipoProductoService.getTiposProducto(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          if (respuesta.data) {
            if (respuesta.data.tiposProducto) {
              respuesta.data.tiposProducto.forEach(tipoProducto => {
                this.tiposProducto.push(
                  new TipoProducto(
                    tipoProducto.IdTipoProducto,
                    tipoProducto.TipoProductoDesc
                  )
                )
              });
            }
          }
        }

        this.cargandoTiposProducto = false;
      },
      () => {
        this.cargandoTiposProducto = false;
      }
    )
  }

  onTipoProductoSelected(event: MatSelectChange) {
    if (event) {
      var tipoProducto = <TipoProducto>event.value;
      this.filtroTipoProductoSelected = tipoProducto.id;
    } else {
      this.filtroTipoProductoSelected = null;
    }

    this.traerProductos();
  }

  onEspecialChange(event: MatCheckboxChange) {
    // si esta marcado traemos unicamente productos especiales
    if (event.checked) {
      this.filtroProductosEspeciales = true;
    } else {
      this.filtroProductosEspeciales = false;

      this.item.customDescripcion = '';
    }

    // vaciar el producto seleccionado
    this.item.producto = null;
    this.productoFormControl.setValue(null);
    this.productoFormControl.updateValueAndValidity();

    this.traerProductos();
  }

  traerProductos() {
    var filtros = {};

    // filtrar por tipo de producto
    if (this.filtroTipoProductoSelected) {
      Object.assign(filtros, {
        IdTipoProducto: this.filtroTipoProductoSelected
      });
    }

    // filtrar por productos especiales  
    Object.assign(filtros, {
      especial: this.filtroProductosEspeciales
    });

    this.productos = [];
    this.cargandoProductos = true;
    this.productoService.getProductos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
      filtros
    ).subscribe( // suscribimos una nueva busqueda
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.productos) {
          respuesta.data.productos.forEach(producto => {
            this.productos.push(<Producto>{
              IdProducto: producto.IdProducto,
              fechaAlta: producto.fechaAlta,
              descripcion: producto.descripcion,
              stock: producto.stock,
              observaciones: producto.observaciones,
              web: producto.web,
              destacado: producto.destacado,
              importeMostrar: producto.importeMostrar,
              importe: producto.importe,
              estado: <ProductoEstado>{
                IdEstado: producto.estado.id,
                descripcion: producto.estado.desc
              },
              tipo: <TipoProducto>{
                id: producto.tipo.id,
                descripcion: producto.tipo.desc,
                categoria: new TipoProductoCategoria(
                  producto.tipo.cat.id,
                  producto.tipo.cat.desc
                )
              },
              caracteristicas: producto.caracteristicas,
            });
          });

          // actualizar opciones del filtro
          this.filtrarProductos();
        }
      },
      () => {
        this.cargandoProductos = false;
      },
      () => {
        this.cargandoProductos = false;
      }
    );
  }

  traerAccesorios(IdTipoProducto: number, TipoProductoCategoriaId: number): void {
    var filtros: any;
    if (IdTipoProducto) {
      filtros = {
        IdTipoProducto: IdTipoProducto
      }
    } else if (TipoProductoCategoriaId) {
      filtros = {
        IdCategoria: TipoProductoCategoriaId
      }
    }

    if (TipoProducto) {
      this.accesorios = [];
      this.cargandoAccesorios = true;
      this.accesorioService.getAccesorios(
        {
          page: null,
          pageSize: null
        },
        {
          sort: 'descripcion',
          order: 'asc'
        },
        filtros
      ).subscribe( // suscribimos una nueva busqueda
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.accesorios) {
            respuesta.data.accesorios.forEach(accesorio => {
              this.accesorios.push(<Accesorio>{
                IdAccesorio: accesorio.IdAccesorio,
                descripcion: accesorio.descripcion,
                importe: accesorio.importe
              });
            });

            // si el ítem tiene asignados accesorios que no vienen en el getAccesorios, debemos removerlos
            // esto puede suceder por ejemplo, si un item especial dejó de serlo
            var itemAccesorioIndex = this.item.accesorios.length;
            while (itemAccesorioIndex-- > 0) {
              // buscamos el accesorio seleccionado para el item, entre todos los accesorios disponibles
              var indexAccesorios = this.accesorios.length;
              var encontrado = false;
              while (indexAccesorios--) {
                if (this.accesorios[indexAccesorios].IdAccesorio == this.item.accesorios[itemAccesorioIndex].IdAccesorio) {
                  encontrado = true;
                  break;
                }
              }

              // si el accesorio no llegó en el getAccesorios
              if (!encontrado) {
                // lo removemos de los seleccionados para el ítem porque ya no esta disponible
                this.item.accesorios.splice(itemAccesorioIndex, 1);

                itemAccesorioIndex = this.item.accesorios.length;
              }
            }
          }
        },
        () => {
          this.cargandoAccesorios = false;
        },
        () => {
          this.cargandoAccesorios = false;
        }
      );
    }
  }

  /**
 * Función que sabe como filtrar
 */
  private filtrarProductos() {
    if (!this.productos) {
      return;
    }

    // get the search keyword
    let search = this.productosFiltroCtrl.value;
    if (!search) {
      this.productosFiltrados.next(this.productos.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // filter the banks
    this.productosFiltrados.next(
      this.productos.filter(producto => {
        return (producto.descripcion.toLowerCase().indexOf(search) > -1);
      })
    );
  }

  onInput(): void { // cuando cambia un dato del formulario emitimos un evento
    this.onItemInput.emit();
  }

  compararProducto(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.IdProducto == tipo2.IdProducto;
    }

    return false;
  }

  onProductoSelected(event: MatSelectChange) {
    var producto = <Producto>event.value;
    this.item.precioUnitario = producto.importe;
    this.itemPrecioProductoAsignado = producto.importe;

    if (this.item.especial) {
      this.traerAccesorios(null, +producto.tipo.categoria.IdCategoria);
    } else {
      this.traerAccesorios(+producto.tipo.id, null);
    }
  }

  onProductoPrecioIncluido(event: MatCheckboxChange): void {
    if (event.checked) {
      // si el precio está incluido, el importe se pone en cero.
      this.item.precioUnitario = 0;
    } else {
      // se seta con el importe original
      this.item.precioUnitario = this.itemPrecioProductoAsignado;
    }

    this.onInput();
  }

  onAccesorioSelected(event: MatCheckboxChange, accesorio: Accesorio): void {
    if (event.checked) {
      // el importe default asignado es el del accesorio
      accesorio.importeAsignado = accesorio.importe;
      accesorio.cantidad = 1;

      this.item.accesorios.push(accesorio);
    } else {
      // quitar del acceorio de los seleccionados
      this.item.accesorios.forEach((accesorioItem: Accesorio, index) => {
        if (accesorioItem.IdAccesorio == accesorio.IdAccesorio) {
          this.item.accesorios.splice(index, 1);
          return;
        }
      });
    }

    this.onInput();
  }

  onPrecioIncluidoSelected(event: MatCheckboxChange, accesorio: Accesorio): void {
    this.item.accesorios.forEach((accesorioItem: Accesorio, index) => {
      if (accesorioItem.IdAccesorio == accesorio.IdAccesorio) {
        // se indica que el importe está includo
        this.item.accesorios[index].precioIncluido = event.checked;

        // si está seleccionado
        if (event.checked) {
          // se setea el importe del accesorio en cero
          this.item.accesorios[index].importeAsignado = 0;
          this.item.accesorios[index].precioDescripcion = 'Incluido';
        } else {
          // se auto completa con el importe del accesorio
          this.item.accesorios[index].importeAsignado = accesorio.importe;
          this.item.accesorios[index].precioDescripcion = '';
        }

        return;
      }
    });

    this.onInput();
  }

  onAccesorioImporteInput(event: any, accesorio: Accesorio): void {
    this.item.accesorios.forEach((accesorioItem: Accesorio, index) => {
      if (accesorioItem.IdAccesorio == accesorio.IdAccesorio) {
        this.item.accesorios[index].importeAsignado = +event.target.value;
        return;
      }
    });
  }

  compararPorId(dato1: any, dato2: any): boolean | null { // le dice al select como comparar
    if (dato1 && dato2) {
      return dato1.id == dato2.id;
    }

    return false;
  }

  getItem(): Item {
    if (this.productoFormControl.hasError('required') ||
      this.cantidadFormControl.hasError('required') ||
      this.cantidadFormControl.hasError('min') ||
      this.cantidadFormControl.hasError('max')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.productoFormControl.markAsTouched();
      this.cantidadFormControl.markAsTouched();

      throw "Datos incorrectos";
    }

    return this.item;
  }
}
